import styled from 'styled-components/macro';
import { darken } from '../../utils';
import { SPACINGS } from '../../utils/style';

export const InputRangeWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  width: ${(p) => p.theme.dimensions.inputWidth};
  padding-top: ${SPACINGS[2]};
`;

export const InputLabelsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: ${SPACINGS[2]};
`;

type InputRangeStyledProps = {
  accent: string;
  background: string;
  activeBackground: string;
};
export const InputRangeStyled = styled.input<InputRangeStyledProps>`
  margin: 0;
  width: 100%;
  padding: 0;
  background-color: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  z-index: 1;

  &:focus {
    outline: none;
  }

  &:focus::-webkit-slider-thumb {
    background-color: ${(p) => darken(p.accent, 0.2)};
  }

  &:focus::-moz-range-thumb {
    background-color: ${(p) => darken(p.accent, 0.2)};
  }

  &:focus::-ms-thumb {
    background-color: ${(p) => darken(p.accent, 0.2)};
  }

  &::-moz-focus-outer {
    border: 0;
  }

  &::-webkit-slider-thumb {
    width: 20px;
    height: 20px;
    margin-top: -7px;
    background-color: ${(p) => p.accent};
    border: 0;
    border-radius: 10px;
    transition: background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out;
    appearance: none;
    box-shadow: ${(p) => p.theme.boxShadows.xs};
  }

  &::-moz-range-thumb {
    width: 20px;
    height: 20px;
    background-color: ${(p) => p.accent};
    border: 0;
    border-radius: 10px;
    transition: background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out;
    appearance: none;
    box-shadow: ${(p) => p.theme.boxShadows.xs};
  }

  &::-ms-thumb {
    width: 20px;
    height: 20px;
    margin-top: 0;
    margin-right: 0.2rem;
    margin-left: 0.2rem;
    background-color: ${(p) => p.accent};
    border: 0;
    border-radius: 10px;
    transition: background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out;
    appearance: none;
    box-shadow: ${(p) => p.theme.boxShadows.xs};
  }

  @media (prefers-reduced-motion: reduce) {
    &::-webkit-slider-thumb {
      transition: none;
    }
  }

  &::-webkit-slider-thumb:active {
    background-color: ${(p) => darken(p.accent, 0.2)};
  }

  &::-webkit-slider-runnable-track {
    width: 100%;
    height: 6px;
    color: transparent;
    cursor: pointer;
    background-color: ${(p) => p.background};
    border-color: transparent;
    content: '';
  }

  @media (prefers-reduced-motion: reduce) {
    &::-moz-range-thumb {
      transition: none;
    }
  }

  &::-moz-range-thumb:active {
    background-color: ${(p) => darken(p.accent, 0.2)};
  }

  &::-moz-range-track {
    width: 100%;
    height: 6px;
    color: transparent;
    cursor: pointer;
    background-color: ${(p) => p.background};
    border-color: transparent;
  }

  &::-moz-range-progress {
    background-color: ${(p) => p.background};
    height: 6px;
  }

  @media (prefers-reduced-motion: reduce) {
    &::-ms-thumb {
      transition: none;
    }
  }

  &::-ms-thumb:active {
    background-color: ${(p) => darken(p.accent, 0.2)};
  }

  &::-ms-track {
    width: 100%;
    height: 6px;
    color: transparent;
    cursor: pointer;
    background-color: transparent;
    border-color: transparent;
    border-width: 0.5rem;
  }

  &::-ms-fill-lower {
    background-color: ${(p) => p.background};
    height: 6px;
  }

  &::-ms-fill-upper {
    margin-right: 15px;
    background-color: ${(p) => p.background};
  }

  &:disabled::-webkit-slider-thumb {
    background-color: ${(p) => p.background};
  }

  &:disabled::-webkit-slider-runnable-track {
    cursor: default;
  }

  &:disabled::-moz-range-thumb {
    background-color: ${(p) => p.background};
  }

  &:disabled::-moz-range-track {
    cursor: default;
  }

  &:disabled::-ms-thumb {
    background-color: ${(p) => p.background};
  }
`;

export const InputRangeTrack = styled.span<{ width: number }>`
  height: 6px;
  background-color: red;
  position: absolute;
  left: 0;
  width: ${(p) => p.width}%;
`;

export const InputRangeBackdrop = styled.div<{ color: string }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 22px;
  background: ${(p) => p.color};
  border-radius: 4px;
  z-index: 0;
`;
